'use client';

import {ReactNode} from 'react';
import Link from 'next/link';
import {usePathname} from 'next/navigation';

function LegalLayout({children}: {children: ReactNode}) {
  const pathname = usePathname();
  const active = (page: string) => pathname === page;

  return (
    <main className="min-h-screen bg-white text-black/80">
      <div className="flex flex-wrap gap-x-4 gap-y-2 border-b border-b-neutral-300 p-2">
        <Link
          href={'/privacy-policy'}
          className={`${
            active('/privacy-policy')
              ? 'rounded-[7px] bg-black/90 text-white'
              : ' '
          } px-4 py-1 text-sm`}
        >
          Privacy Policy
        </Link>

        <Link
          href={'/cookies'}
          className={`${
            active('/cookies') ? 'rounded-[7px] bg-black/90 text-white' : ' '
          } px-4 py-1 text-sm`}
        >
          Cookies
        </Link>

        <Link
          href={'/terms-and-conditions'}
          className={`${
            active('/terms-and-conditions')
              ? 'rounded-[7px] bg-black/90 text-white'
              : ' '
          } px-4 py-1 text-sm`}
        >
          Terms And Conditions
        </Link>
      </div>
      <div className="flex flex-col px-5 pt-3 pb-10">{children}</div>
    </main>
  );
}

export default LegalLayout;
